// Strings of Settings › Posting and the waiting state of vouchers and journal entries (migration 034,
// docs/chart-and-posting.md section 4). Arabic marked "new" needs review by an Arabic copy editor.
export const POSTING_STRINGS: Record<"en" | "ar", Record<string, string>> = {
  en: {
    setPosting: "Posting",
    psIntro: "For each kind of document, choose whether finishing it posts it to the accounts at once (Automatic) or waits for someone allowed to post it (Manual). Changing a choice never posts anything that is waiting.",
    psOwnerOnly: "Only the business owner, or a user they allow to manage posting, changes these settings.",
    psNoOwner: "No business owner is assigned, so these settings cannot be changed yet.",
    psDoc: "Document",
    psMode: "Posting",
    psAutomatic: "Automatic",
    psManual: "Manual",
    psDefault: "As before",
    psWaiting: "Waiting",
    psWaitingTotal: "Waiting amount",
    psChanged: "Changed",
    psSaved: "{d}: posting is now {m}. Nothing waiting was posted.",
    psRightsTitle: "Who else may post",
    psRightsIntro: "The business owner posts every kind. Allow other users to post the kinds ticked here. Manage lets a user change these settings and give posting rights (only the owner gives Manage).",
    psUser: "User",
    psManage: "Manage",
    psRightsSaved: "Posting rights of {u} saved",
    psOwnerAll: "Business owner: posts every kind",
    psPendingTitle: "Waiting for posting",
    psPendingNone: "Nothing is waiting for posting.",
    psPostSelected: "Post selected",
    psPosted: "{n} posted",
    psNotPosted: "{n} not posted",
    psSince: "Waiting since",
    psBy: "Sent by",
    doc_sale: "Sales invoices", doc_sale_refund: "Sales refunds", doc_purchase: "Purchase invoices", doc_purchase_refund: "Purchase refunds",
    doc_expense: "Expenses", doc_deposit: "Deposits", doc_withdraw: "Withdrawals", doc_cash_transfer: "Cash transfers", doc_collect: "Collections",
    doc_payment: "Payments", doc_opening_balance: "Opening balances", doc_journal: "Journal entries",
    awaitingPosting: "Waiting for posting",
    sendForPosting: "Send for posting",
    sentForPosting: "Sent for posting. It is not in the accounts until someone allowed to post it posts it.",
    awaitingCount: "Waiting {n}"
  },
  ar: {
    setPosting: "الترحيل", // new
    psIntro: "لكل نوع من المستندات اختر: هل يُرحَّل إلى الحسابات فور إتمامه (تلقائي) أم ينتظر من يُسمح له بالترحيل (يدوي). تغيير الاختيار لا يرحّل شيئًا منتظرًا.", // new
    psOwnerOnly: "مالك المنشأة وحده، أو من يسمح له بإدارة الترحيل، يغيّر هذه الإعدادات.", // new
    psNoOwner: "لم يُعيَّن مالك للمنشأة، فلا يمكن تغيير هذه الإعدادات بعد.", // new
    psDoc: "المستند", // new
    psMode: "الترحيل", // new
    psAutomatic: "تلقائي", // new
    psManual: "يدوي", // new
    psDefault: "كما كان", // new
    psWaiting: "منتظر", // new
    psWaitingTotal: "المبلغ المنتظر", // new
    psChanged: "آخر تغيير", // new
    psSaved: "{d}: أصبح الترحيل {m}. لم يُرحَّل شيء منتظر.", // new
    psRightsTitle: "من يُسمح له بالترحيل أيضًا", // new
    psRightsIntro: "مالك المنشأة يرحّل كل الأنواع. اسمح لمستخدمين آخرين بترحيل الأنواع المحددة هنا. الإدارة تتيح تغيير هذه الإعدادات ومنح صلاحيات الترحيل (المالك وحده يمنح الإدارة).", // new
    psUser: "المستخدم", // new
    psManage: "الإدارة", // new
    psRightsSaved: "حُفظت صلاحيات الترحيل لـ {u}", // new
    psOwnerAll: "مالك المنشأة: يرحّل كل الأنواع", // new
    psPendingTitle: "بانتظار الترحيل", // new
    psPendingNone: "لا يوجد شيء بانتظار الترحيل.", // new
    psPostSelected: "ترحيل المحدد", // new
    psPosted: "رُحّل {n}", // new
    psNotPosted: "لم يُرحَّل {n}", // new
    psSince: "منتظر منذ", // new
    psBy: "أرسله", // new
    doc_sale: "فواتير المبيعات", doc_sale_refund: "مرتجعات المبيعات", doc_purchase: "فواتير المشتريات", doc_purchase_refund: "مرتجعات المشتريات", // new
    doc_expense: "المصروفات", doc_deposit: "الإيداعات", doc_withdraw: "السحوبات", doc_cash_transfer: "التحويلات النقدية", doc_collect: "سندات القبض", // new
    doc_payment: "سندات الصرف", doc_opening_balance: "الأرصدة الافتتاحية", doc_journal: "قيود اليومية", // new
    awaitingPosting: "بانتظار الترحيل", // new
    sendForPosting: "إرسال للترحيل", // new
    sentForPosting: "أُرسل للترحيل. لا يدخل الحسابات حتى يرحّله من يُسمح له بذلك.", // new
    awaitingCount: "منتظر {n}" // new
  }
};
